import {Injectable} from "@angular/core";
import {
  BokkzClient,
  BokkzDivDataService, Dividendbelasting, DividendTaxEntity,
  DivRekenService,
  ErrorMessage,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {ToastService} from "@snelstart/ui-toast";

@Injectable({providedIn: 'root'})
export class BokkzDivLogic {

  public errorResponse = {} as ErrorMessage[];
  public dividendTaxEntity = {} as DividendTaxEntity;
  public aantalValidaties = {} as number;
  public errorString = '';

  constructor(private bokkzClient: BokkzClient,
              private divRekenservice: DivRekenService,
              public dataService: BokkzDivDataService,
              public toastService: ToastService
  ) {
    if (this.dataService) {
      //Hier zorgen we ervoor we ervoor dat we nieuwe data binnenkrijgen en stoppen deze in de variabelen.
      this.dataService.dividendTaxEntity.subscribe((value) => (this.dividendTaxEntity = value));
      this.dataService.errorResponse.subscribe((value) => (this.errorResponse = value));
      this.dataService.aantalValidaties.subscribe((value) => (this.aantalValidaties = value));
    }
  }

  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  private getEntity() : DividendTaxEntity {
    return this.getFromSessionStorage('dividendTaxEntity') || <DividendTaxEntity>{};
  }

  public postDividendTaxEntity(clientId: string, sendToAuthorities: boolean) {
    this.bokkzClient.postDividendTax(clientId, sendToAuthorities, this.getEntity()).subscribe({
      next: (response) => {
        if (response && response.aangifte != null) {
          this.dataService.updateAangifte(response.aangifte)
        }
      },
      error: (err) => {
        console.log(err)
        this.toastService.showErrorMessage("De gegevens zijn niet opgeslagen")
      },
      complete: () => console.log("SUCCES POST DIVIDEND ENTITY")
    })
  }

  public getCalculation(dividendTaxEntity: DividendTaxEntity) {
    if (dividendTaxEntity.aangifte && dividendTaxEntity.aangifte.contactPersoon) {
      this.divRekenservice.getDividendTaxCalculation(dividendTaxEntity.aangifte).subscribe({
        next: (response) => {
          if (response.contactPersoon != null) {
            this.dataService.updateAangifte(response as Dividendbelasting);
            dividendTaxEntity.aangifte = response;
            this.dataService.updateDividendTaxEntity(dividendTaxEntity);
          }
        },
        error: (err) => {
          console.log("Div Berekening mislukt", err)
        },
        complete: () => console.log("Div Berekening succes")
      })
    }
  }

  public getValidation() {
    setTimeout(() => {
      this.divRekenservice.getDividendTaxValidation(this.getEntity().aangifte!).subscribe({
        next: (response) => {
          if (response.contactPersoon != null) {
            this.dataService.updateAantalValidaties(0);
            this.dataService.updateAangifte(response as Dividendbelasting);
          }
          else {
            if ("HV000028: Unexpected exception during isValid call." === response as unknown as string) {
              this.errorString = response as unknown as string;
              const error: ErrorMessage[] = [{
                error: "server.error",
                response: "HV000028: Unexpected exception during isValid call."
              }]
              this.dataService.updateErrorResponse(error);
              this.dataService.updateAantalValidaties(1);
              this.dataService.updateAangifte(response as Dividendbelasting);
            } else {
              this.dataService.updateErrorResponse(response as unknown as ErrorMessage[]);
              this.dataService.updateAantalValidaties(this.errorResponse.length);
              this.dataService.updateAangifte(response as Dividendbelasting);
            }
          }
        },
        error: (err) => {
          this.dataService.updateAantalValidaties(0);
          console.log(err)
        },
        complete: () => console.log("Succes validation db")
      })
    }, 1200)
  }

}
